/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import { Button, CopySnippetField, Tip, Icon, CopyField } from '@insticator/insticator-ui/dist/material';
// styles
import injectSheet from 'react-jss'
import styles from './previewmodecode_styles'


/* ========== ~~~~~~~~~~ PRODUCT MANAGER: SITE SETUP : FEATURES ~~~~~~~~~~ ========== */
const PreviewModeCode = injectSheet(styles)((props) => {
  return (
    <div className={`previewmodecode ${props.classes.previewmodecode}`}>
        {/* <CopyField
          description={
            <span>Preview mode code
              <Tip 
                space={'none'} 
                icon={'question-circle'} 
                label={''} 
                content={`
                To view a preview of what your "Draft" product setup would look like in your website, copy this code, navigate to an article on your site, 
                and append this code to the end of the page url located in the address bar of the browser you’re using. 
                Reload the page. This will engage "Preview Mode". The changes you see there will only be visible to you, not the general public.
                `} 
              />
            </span>}
          defaultValue={`?insticatorPreviewMode=true`}
          ctaPosition={'inline'}
          icon={''}
        /> */}
        <CopyField 
          name={'copyfield'}
          defaultValue={'?insticatorPreviewMode=true'} 
          handleCopy={() => props?.handleCopy()} 
          height={'inline'} 
          readOnly={true} 
          margin={'16px'}
          scrollbarColor={'transparent'} 
          ctaVariant={'primary'} 
          icon={''} 
          ctaPosition={'inline'} 
          fieldType={'text'} 
          copyItemName={''} 
        />

        {/* <Button
          klass={'configbutton'}
          name={'gotosite'}
          variant={'system'}
          text={'Go to site'}
          handleClick={() => window.open(`https://${siteURL}`, '_blank')}
        /> */}
            
      {/* <Space alignItems={'flex-start'}>
        <Icon name={'exclamation-circle'} /> 
          <p>
          To enable “Preview mode” first click “Save Draft”, then paste this code into the address bar of your site and reload the page. 
          After your testing is complete, click “Set as Current” to set these changes <strong>LIVE!</strong>
          </p>
      </Space> */}
    </div>
   
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PreviewModeCode;